import type { NavigateFunction } from 'react-router-dom';

let _navigate: NavigateFunction | null = null;

export function registerAuthNavigate(fn: NavigateFunction): void {
  _navigate = fn;
}

export function triggerAuthRedirect(): void {
  if (_navigate) {
    _navigate('/login', { replace: true });
  } else {
    // Fallback: bridge not yet registered (app not yet mounted)
    globalThis.location.href = '/login';
  }
}
